import script from "./GeolocationButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeolocationButton.vue?vue&type=script&setup=true&lang=ts"

import "./GeolocationButton.vue?vue&type=style&index=0&id=67055322&lang=css"

const __exports__ = script;

export default __exports__